<template>
  <div class="">
    <div class="">
      <div class="w-full flex text-6b text-c14 2xl:text-c16 font-c4 text-left mb-6 text-titre diviser py-2 px-3 rounded-t-14">
        <div class="w-1/3">
          Entreprise/Commerce
        </div>

        <div class="w-1/4 ml-4">
          Gérant
        </div>

        <div class="w-1/5 ml-4">
          Catégories
        </div>

        <div class="w-1/4 ml-4">
          Zone/Religion
        </div>

        <div class="w-1/4 ml-4">
          Taille
        </div>
      </div>
    </div>
  </div>
</template>

<script>
</script>